'use client'

import { m } from 'framer-motion'

import { FINAL_CTA_BENEFITS } from '@/components/sections/final-cta/model'

export function FinalCtaBenefits() {
  return (
    <m.div
      initial={{ opacity: 0, x: -40 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ delay: 0, duration: 0.6 }}
      className="space-y-6 lg:col-span-5"
    >
      <h2 className="home-title leading-tight text-white">
        Следующий шаг -{' '}
        <span className="bg-gradient-to-r from-blue-400 via-purple-400 to-cyan-400 bg-clip-text text-transparent">
          за вами
        </span>
      </h2>
      <p className="home-lead text-gray-400">
        Один разговор может изменить ваш бизнес. Напишите - и узнаете, как именно.
      </p>

      <div className="space-y-4 pt-4">
        {FINAL_CTA_BENEFITS.map((item, index) => (
          <m.div
            key={item.text}
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 + index * 0.1 }}
            whileHover={{ x: 10, scale: 1.02 }}
            className="group flex cursor-default items-center gap-5 rounded-2xl border border-white/5 bg-white/[0.03] p-5 transition-all duration-300 hover:border-blue-500/30 hover:bg-blue-500/5"
          >
            <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-blue-500/20 to-purple-500/20 transition-colors group-hover:from-blue-500/30 group-hover:to-purple-500/30">
              <item.icon className="h-7 w-7 text-blue-400" />
            </div>
            <div>
              <p className="text-lg font-semibold text-white">{item.text}</p>
              <p className="home-subnote text-gray-500">{item.sub}</p>
            </div>
          </m.div>
        ))}
      </div>
    </m.div>
  )
}
